import store from '@/store';
import { setStorageItem, getStorageItem, removeStorageItem, STORAGE_KEYS } from '@/utils/storage';

/**
 * 获取当前认证状态
 * @returns {boolean} 是否已认证
 */
export function isAuthenticated() {
  const token = store.getters['user/token'] || getStorageItem(STORAGE_KEYS.TOKEN);
  return !!token;
}

// 保持向后兼容
export const isAuthorized = isAuthenticated;

/**
 * 获取当前token
 * @returns {string|null} token值
 */
export function getToken() {
  return store.getters['user/token'] || getStorageItem(STORAGE_KEYS.TOKEN);
}

// 设置授权状态
export function setAuthorized(token) {
  // 将token存储到Vuex store中（自动同步到存储）
  store.dispatch('user/setToken', token);
}

// 清除授权状态
export function clearAuthorized(callback) {
  // 使用统一的应用状态清理（不包含租户信息）
  store.dispatch('user/clearAllUserData');
  store.dispatch('corp/clearAllCorpData');
  callback && callback();
}

// 初始化授权状态
export function initAuthorized() {
  // 使用统一的应用状态初始化
  return initAppState();
}

// 设置外部联系人ID
export function setExternalUserId(userId) {
  // 存储到Vuex store中（自动同步到存储）
  store.dispatch('user/setExternalUserId', userId);
}

// 清除外部联系人ID
export function clearExternalUserId() {
  // 从Vuex store中清除（自动同步清除存储）
  store.dispatch('user/clearExternalUserId');
}

// 设置租户和医生信息
export function setTenantInfo(tenantId, phone) {
  if (tenantId) {
    setStorageItem(STORAGE_KEYS.TENANT_ID, tenantId);
  }
  if (phone) {
    setStorageItem(STORAGE_KEYS.PHONE, phone);
  }
}
//设置微信企业信息
export function setWxCpConfig(corpId,agentId) {
  if (corpId || agentId) {
    setStorageItem(STORAGE_KEYS.CORP_ID, corpId);
    setStorageItem(STORAGE_KEYS.AGENT_ID, agentId);
  }
}

// 获取租户ID
export function getTenantId() {
  return getStorageItem(STORAGE_KEYS.TENANT_ID);
}

// 获取登录手机号
export function getPhone() {
  return getStorageItem(STORAGE_KEYS.PHONE);
}

// 清除租户信息
export function clearTenantInfo() {
  removeStorageItem(STORAGE_KEYS.TENANT_ID);
  removeStorageItem(STORAGE_KEYS.PHONE);
}

// ========== 应用状态管理 ==========

/**
 * 初始化应用状态
 * 在main.js中调用，用于恢复用户登录状态和企业信息
 */
export function initAppState() {
  // 恢复用户状态（token, externalUserId）
  store.dispatch('user/restoreUserState');
  
  // 恢复企业微信配置（corpId, agentId）
  store.dispatch('corp/restoreCorpState');
  
  console.log('应用状态已初始化');
  return getToken();
}

/**
 * 清理所有应用状态
 * 用于用户退出登录时清理所有状态
 */
export function clearAppState() {
  // 清理用户状态
  store.dispatch('user/clearAllUserData');
  
  // 清理企业微信状态
  store.dispatch('corp/clearAllCorpData');
  
  // 清理租户信息
  clearTenantInfo();
  
  console.log('应用状态已清理');
}

/**
 * 检查应用初始化状态
 * @returns {Object} 包含各种状态的对象
 */
export function getAppInitState() {
  return {
    hasToken: store.getters['user/isAuthenticated'],
    hasCorpInfo: store.getters['corp/hasCorpInfo'],
    userInfo: {
      token: store.getters['user/token'],
      externalUserId: store.getters['user/externalUserId']
    },
    corpInfo: store.getters['corp/corpInfo'],
    tenantInfo: {
      tenantId: getTenantId(),
      doctorsId: getDoctorsId()
    }
  };
} 